import type { ConcreteColumnTemplate, KnownColumnTemplateKey } from '@thinkalpha/ui-types/contracts/column-template';
import type { ResourceQuery, ResourceQueryResponseWithMeta } from '@thinkalpha/ui-types/contracts/resource-query';
import { firstValueFrom } from 'rxjs';
import { api } from 'src/api';
import { getColumnTemplate, getDefaultColumnTemplate as getDefaultColumnTemplateObs } from 'src/lib/column-templates';
import { processQuery } from 'src/lib/paging';

export async function getColumnTemplateById(id: string): Promise<ConcreteColumnTemplate> {
    return firstValueFrom(getColumnTemplate(id));
}

export async function getDefaultColumnTemplate(key: KnownColumnTemplateKey): Promise<ConcreteColumnTemplate> {
    return firstValueFrom(getDefaultColumnTemplateObs(key));
}

export const getColumnTemplatesQuery = async (
    query: ResourceQuery,
): Promise<ResourceQueryResponseWithMeta<ConcreteColumnTemplate>> => {
    return (await api.get(`/column-templates/query${processQuery(query)}`)).data;
};
